import React from 'react'
import PropTypes from 'prop-types'
import { Loader } from 'components/UIElements'

const LoadingBlock = ({ label = 'Loading…' }) => (
  <div className='se-loading' role='status' aria-live='polite'>
    <Loader inContainer size={28} />
    <span>{label}</span>
  </div>
)

LoadingBlock.propTypes = {
  label: PropTypes.string,
}

export default LoadingBlock
